import type { HelpEntry } from '../types'

export const HELP: HelpEntry[] = [
  {
    id: 'capabilities.browser',
    title: 'What can I ask?',
    body: 'Every example here is a request FuseGrid is built to answer. “Copy for Claude/ChatGPT” copies it ready to paste; “Run in the sidebar” sends it to the FuseGrid assistant in Excel.',
    verified_by: ['fusegrid_v2/src/components/connect/catalog.ts:64', 'fusegrid_v2/src/components/connect/CapabilityBrowser.tsx:24'],
  },
  {
    id: 'capabilities.role_filter',
    title: 'Filtering by role',
    body: 'Some requests change data and need an editing role. Pick a role to see only what someone with that role can run.',
    verified_by: ['fusegrid_v2/src/components/connect/catalog.ts:51', 'fusegrid_v2/src/components/connect/catalog.ts:54'],
  },
  {
    id: 'capabilities.get_financial_statements',
    title: 'Get financial statements',
    body: 'The monthly P&L, balance sheet or cash flow for a company, optionally compared with plan, the prior year or the prior month.',
    verified_by: ['fusegrid_v2/docs/fusegrid-everywhere/fixtures/capability-catalog.sample.json:9'],
  },
  {
    id: 'capabilities.add_to_workbook',
    title: 'Add to my Excel workbook',
    body: 'Places a refreshable table, sheet, view or report section in the connected Excel workbook. Nothing changes until the workbook owner approves it in the FuseGrid pane.',
    verified_by: ['fusegrid_v2/docs/fusegrid-everywhere/fixtures/capability-catalog.sample.json:31', 'fusegrid_v2/docs/fusegrid-everywhere/fixtures/capability-catalog.sample.json:33', 'fusegrid_v2/server/migrations/244_cfo_host_operations.sql:25'],
  },
  {
    id: 'capabilities.ask_fusegrid',
    title: 'Ask FuseGrid',
    body: 'Hand FuseGrid a request in plain words. It answers read requests directly and turns a change into a ready-to-approve call instead of making it.',
    verified_by: ['fusegrid_v2/docs/fusegrid-everywhere/fixtures/capability-catalog.sample.json:53'],
  },
]
